/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_CrosswindInputs */

const en_ui_weather_crosswind = /** @type {(inputs: Ui_Weather_CrosswindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crosswind`)
};

const de_ui_weather_crosswind = /** @type {(inputs: Ui_Weather_CrosswindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenwind`)
};

/**
* | output |
* | --- |
* | "Crosswind" |
*
* @param {Ui_Weather_CrosswindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_crosswind = /** @type {((inputs?: Ui_Weather_CrosswindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_CrosswindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_crosswind(inputs)
	return de_ui_weather_crosswind(inputs)
});